import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import {
  DisplayAttachmentsAgGridComponent,
  Attachment,
} from '@wilson/shared-components';

@Component({
  selector: 'wilson-qualification-attachments-renderer',
  template: `
    <wilson-display-attachments-ag-grid
      [attachments]="attachments"
      [maxAmount]="1"
      tooltipDirection="left"
    />
  `,
  providers: [],
  imports: [DisplayAttachmentsAgGridComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class QualificationAttachmentsRendererComponent
  implements ICellRendererAngularComp
{
  public attachments: Attachment[] = [];

  agInit(params: ICellRendererParams): void {
    this.attachments = params.value || [];
  }

  refresh(params: ICellRendererParams): boolean {
    this.attachments = params.value || [];
    return true;
  }
}
